<template>
	<div class="dashboard">
		<top-header></top-header>
		<div class="breadcrumb-section mb-md-5 py-md-3 py-sm-2">
			<b-container>
				<b-row>
					<b-col class="text-left">
						<div class="my-md-3 font-xl">PRODUCT</div>		
					</b-col>
					<b-col class="text-right">
						<div class="my-md-3 font-xl">HOME / PRODUCT</div>		
					</b-col>
				</b-row>
			</b-container>
		</div>
		<b-container>
			<div class="mx-3">
			<b-row class="product-info py-3" style="background-color:#fff;" v-if="product.id">
				<b-col cols="1" class="px-0">
                    <b-list-group>
						<b-list-group-item class="p-0" v-for="item in filterImages(product.gallery_images)" :key="item" @click="product.image = item"><b-img :src="$root.MEDIAPATH+'products/'+item.replace('_rg','_th')" fluid></b-img></b-list-group-item>
					</b-list-group>
				</b-col>
				<b-col cols="5" md="5" class="product-images">
                    <b-img :src="$root.MEDIAPATH+'products/'+product.image" fluid></b-img>
				</b-col>
				<b-col cols="6" md="6">
                    <div class="product-title">{{product.title}}</div>
                    <div class="product-sku">{{product.sku}}</div>
					<div class="product-desc">{{product.short_description}}</div>
					<div v-if="product.product_type == 2">
						<b-row class="mb-3" v-for="(item, index) in product.variation_attributes" :key="item">
							<b-col >
								<b-row>
									<b-col>
										<label>{{item}}</label>
									</b-col>
								</b-row>
								<b-row>
									<b-col v-for="variationitem in filterAttribute(product.variations, index)" :key="variationitem.sku" cols="2" class="px-1">
										<div class="product-attribute" v-bind:class="{ active: selected_attributes[index] == variationitem.attributes[index].value }" v-on:click="onSelectAttribute(variationitem, index)">
											<!--{{variationitem.attributes[index]}}-->
											<b-img :src="variationitem.src" style="width:30px;"></b-img> 
										</div>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<p>{{selected_attributes}}</p>
					</div>
						<div v-if="product.special_price>0 && product.special_price!=null" >
							<div class="product-price">{{$root.currency()+$root.tofixed(product.special_price * product_qty, 2)}} <small class="peritem" v-if="product_qty > 1">({{$root.currency()+$root.tofixed(product.special_price, 2)}} per item)</small></div>
								<p class="font-md my-1">M.R.P.:<del>{{$root.currency()+$root.tofixed(product.price, 2)}}</del></p>
								<p class="font-md mt-1 mb-3">You Save: {{$root.currency()+$root.tofixed(product.price - product.special_price, 2)}} ({{$root.currency()+$root.tofixed((product.price - product.special_price)*100/product.price, 0)}}% off)</p>
							</div>
						<div v-else>
							<div class="product-price">{{$root.currency()+$root.tofixed(product.price, 2)}}</div>
						</div>
					
				</b-col>
			</b-row>
			
			<div v-else class="text-center">
				<b-spinner variant="primary" label="Text Centered"></b-spinner>
			</div>
			</div>
		</b-container>
		<b-container>
			
			<b-row>
				<b-col>
					<h4 class="text-left pt-3 my-3">PRODUCT REVIEW</h4>
					<div class="boxshadow mb-3">
						<b-tabs content-class="mt-3 px-3 py-2" class="mt-2" align="left">
							<b-tab title="REVIEW & RATINGS" active>
								<b-row class="text-center">
									<b-col class="text-center" cols="4">
										<b-form-rating class="w-50" readonly no-border :value="reviewData.total_review/reviewData.total_user" precision="2"></b-form-rating>
										<div class="rate-value w-50">{{$root.tofixed(reviewData.total_review/reviewData.total_user,1)}} / {{reviewData.total_user}}</div> 
										<div class="w-50 font-sm">Based on<br>{{reviewData.total_user}} Ratings</div>
									</b-col>
									<b-col cols="8">
										<div class="row">
											<label>Rate this product</label>
										</div>
										<div class="row mb-2">
											<b-form-rating id="rating-inline" inline no-border @change="addreview()" size="lg" v-if="reviewData.iRateit==1" readonly :value="reviewData.iRate" ></b-form-rating>
											
											<b-form-rating v-else id="rating-inline" inline no-border v-model="reviewForm.rating" @change="addreview()" size="lg"></b-form-rating>
										</div>
										<div class="row mb-1" v-if="reviewData.iRateit!=1">
											<b-form @submit="onSubmitReview" style="width:90%">
												<b-form-group label="Review Subject" label-for="review_subject" label-align="left">
													<b-form-input
														id="review_subject"
														v-model="reviewForm.subject"
														required
														placeholder="Review Subject"
													></b-form-input>
													</b-form-group>
													<b-form-group label="Description:" label-for="review_description20" label-align="left">
													<b-form-textarea
														id="review_description20"
														v-model="reviewForm.description"
														placeholder="Enter Description..."
														rows="2"
														max-rows="6"
														required
													></b-form-textarea>
													</b-form-group>
													<b-button type="submit" variant="primary">Submit</b-button>
											</b-form>
										
										</div>
										
										
										
										
										
									</b-col>
									<!--<b-col>
										<b-form-rating id="rating-inline" inline no-border value="0" @change="addreview()"></b-form-rating>
										<p>Rate it</p>
										<p>Have you purchased this item?</p>
									</b-col> 
									<b-col>
										Write a review
										<b-link class="btn2 btn-solid" @click="addreview()">WRITE REVIEW---</b-link>
									</b-col>-->
								</b-row>
							</b-tab>
						</b-tabs>
					</div>
					<div class="boxshadow mb-3 p-3">
						<h4>Wow</h4>
						<div class="d-flex flex-row w-50">
						
							<b-form-rating style="max-width:130px" class="p-0" readonly no-border value="4.5" precision="2"></b-form-rating><span class="px-3">|</span><label>Tanushree Ghosh</label><span class="px-3">|</span><div>29-08-2020</div>
							
						</div>
						<p>Perfect colour..I just love it ??</p>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<product-swiper :products="related_products" :showQuickViewListener="$root.showQuickView" heading="Related Products"></product-swiper>
		</b-container>
		<top-footer></top-footer>

		<quickview :modaldata="$root.quickview_data"></quickview>
	</div>
</template>
<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import ProductSwiper from "@/components/product-swiper.vue";
import Quickview from "@/components/quickview.vue";
export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
		"product-swiper": ProductSwiper,
		"quickview": Quickview,
	},
	mounted(){
		this.initload();
		//console.log('Current Swiper instance object', this.mySwiper)
		//this.$refs.rpswiper.$swiper.slideTo(3, 1000, false);
	},
	data() {
		return{
            product: {
				price: 0,
				special_price: 0,
				bars: [{id:1, value:4},{id:2, value:3},{id:3, value:2.4}]
			},
			product_qty: 1,
			modal_data: {
				price: 0,
				special_price: 0
			},
			modal_data_qty: 1,
			qty_options: [
				{ value: 1, text: '1' },
				{ value: 2, text: '2' },
				{ value: 3, text: '3' },
				{ value: 4, text: '4' },
				{ value: 5, text: '5' },
				{ value: 6, text: '6' }
			],
			url: this.$root.WEBURL+'loadproduct',
			addreviwurl: this.$root.WEBURLNEW+'new-rating',
			empty_data: {
				price: 0,
				special_price: 0
			},
			related_products: [],
			selected_attributes: [],
			textVal:'',
			reviewForm:{
				subject: '',
				description: '',
				rating:null,
				productid:'',
			},
			reviewData:{"total_review":10,"total_user":3,"iRate":4,"iRateit":0,"reviewRate":{"rate5":20,"rate4":3,"rate3":1,"rate2":6,"rate1":0}}, 
			
		};
	},
	methods: {
		addreview(){
			var self = this;
			if(self.$root.customer_info.access_key == ''){
				self.$router.push({
					name: 'Login',
					params: {
						redirect: '/product/'+self.$route.params.productid+'/review/add'
					}
				});
			}
		},
		resetQuickView(){
			//var self = this;
			//self.modal_data = Object.assign({}, self.empty_data);
		},
		onSelectAttribute(variation, index){
			var t = this.selected_attributes.slice();
			t[index] = variation.attributes[index].value;
			this.selected_attributes = t;
			
			//console.log(">>> "+this.selected_attributes2);
		},
		filterAttribute(variations, index){
			var self = this;
			var filterarr = [];
			if(index == 0){
				return variations.filter(function (variation) {
					if(filterarr.indexOf(variation.attributes[index].value) == -1){
						filterarr.push(variation.attributes[index].value);
						return true;
					}
					return false;
				})
			}else{
				return variations.filter(function (variation) {
					console.log(self.selected_attributes[index-1]);
					if(variation.attributes[index-1].value == self.selected_attributes[index-1]){
						//filterarr.push(variation.attributes[index].value);
						return true;
					}
					return false;
				})
			}
		},
		filterAttribute222(variations, index){
			var filterarr = [];
			if(index == 0){
				return variations.filter(function (variation) {
					if(filterarr.indexOf(variation.attributes[index].value) == -1){
						filterarr.push(variation.attributes[index].value);
						return true;
					}
					return false;
				})
			}else{
				return variations.filter(function (variation) {
					if(filterarr.indexOf(variation.attributes[index].value) == -1){
						filterarr.push(variation.attributes[index].value);
						return true;
					}
					return false;
				})
			}
		},
		filterImages: function (items) {
			return items.filter(function (item) {
				return item  != ''
			})
		},
		initload(){
			var self = this;
			
			//alert(self.$root.customer_info.access_key); 	 	
			
			/* check user is login */
			if(self.$root.customer_info.access_key == ''){
				self.$router.push({
					name: 'Login',
					params: {
						redirect: '/product/'+self.$route.params.productid+'/review/add'
					}
				});
			}
			/* ---------------------- */
			
			self.axios.post(self.url, {
                accesskey: self.$session.get('access_key'),
                productid: self.$route.params.productid
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.product = response.data.result.product_record;
					self.product.gallery_images = JSON.parse(self.product.gallery_images);
					//self.products.bars = 
					if(self.product.product_type == 2){
						self.product.variation_attributes = self.product.variation_attributes.split("|");
						self.product.variations = JSON.parse(self.product.variations);
						self.selected_attributes = self.product.default_variation.split("|");
						//self.selected_attributes2 = self.product.default_variation.split("|");
					}
					self.related_products = response.data.result.related_products;
					
					//self.selected_attributes = 'Red';
					
					//console.log('Current Swiper instance object', self.mySwiper);
					//self.mySwiper.update();
					//self.mySwiper.slideTo(2, 1000, false)
					
                    //console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		onSubmitReview(evt) {
			evt.preventDefault();
			this.reviewForm.productid = this.$route.params.productid;
			alert(JSON.stringify(this.reviewForm));
			console.log(this.reviewForm);
			
			var self = this;
			//alert(this.$route.params.subcategory);
			
			self.axios.post(self.addreviwurl, {
                accesskey: self.$root.customer_info.access_key,
                data: this.reviewForm
			})
			.then(function (response) {
			console.log("MYreview01"+response);
				if(response.data.error == 0 || response.data.error == '0'){	
					self.$bvToast.toast(response.data.message, {
						title: 'Product Review',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'success',
						solid: true,
						appendToast: true
                    })
					self.$router.push('/product/'+self.$route.params.productid);
                   
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			
		},
		
	}
}
</script>